<div
  class="column-chooser-list flex flex-col space-y-2"
  cdkDropList
  [cdkDropListData]="getFilteredColumns()"
  (cdkDropListDropped)="onDrop($event)"
>
  @for (column of getFilteredColumns(); track column.headerName) {
    <div class="column-chooser-item flex-col" cdkDrag [cdkDragDisabled]="!reorder()">
      <div [class.ml-[-7px]]="!column.children?.length && !column.root">
        <ng-container
          [ngTemplateOutlet]="chooserItem"
          [ngTemplateOutletContext]="{ column: column }"
        />
      </div>

      <div
        *cdkDragPreview
        class="flex w-[400px] flex-col gap-1 rounded border border-aux-blue bg-white p-2 shadow-lg"
      >
        <ng-container
          [ngTemplateOutlet]="chooserItem"
          [ngTemplateOutletContext]="{ column: column }"
        />
      </div>
    </div>
  }
</div>

<ng-template #chooserItem let-column="column">
  <div class="flex items-center">
    <aux-icon
      [name]="column.isCollapsed ? 'ChevronDown' : 'ChevronUp'"
      (click)="toggleCollapse(column)"
      class="flex-shrink-0 cursor-pointer"
      [class.invisible]="!(column.root && !!column.children?.length)"
    />
    <div class="mr-[16px] grid w-full grid-cols-[1fr_auto] place-items-center gap-1">
      <aux-checkbox
        [checked]="!!column.checked"
        [indeterminate]="isRootColumnIndeterminate(column)"
        (customChange)="onCheckboxChange($event, column)"
        class="w-full truncate [&_input[type='checkbox']]:m-[4px] [&_label]:!ml-[4px]"
        [id]="'column-chooser-checkbox-' + column.headerName + '-' + column.field"
      >
        <div class="flex w-full items-center gap-1">
          @if (reorder()) {
            <div class="flex cursor-grab items-center gap-1" cdkDragHandle>
              <aux-icon name="GridDots" class="text-aux-blue-dark" [size]="16" />
            </div>
          }
          <p
            class="truncate"
            #columnName
            [auxTooltip]="columnName.offsetWidth < columnName.scrollWidth ? column.headerName : ''"
          >
            {{ column.headerName }}
          </p>
        </div>
      </aux-checkbox>
      @if (showPinIcons() && !column.children?.length && !column.ignoreChildrenSelection) {
        <aux-icon
          name="Pinned"
          class="flex-shrink-0 cursor-pointer text-aux-blue-dark"
          [class.!fill-aux-blue-dark]="column.pinned"
          [size]="20"
          (click)="$event.stopPropagation(); togglePin(column)"
          [auxTooltip]="column.pinned ? 'Unpin column' : 'Pin column to left'"
        />
      }
    </div>
  </div>

  @if (!column.isCollapsed && column.children?.length) {
    <div class="ml-4 mt-2 pl-[18px]">
      <aux-column-chooser-items
        [columns]="column.children || []"
        [isChildrenNode]="true"
        [(mutableColumns)]="column.children"
        (childrenChanged)="onChildrenChanged($event, column.headerName)"
        [reorder]="reorder()"
        [showPinIcons]="showPinIcons()"
      />
    </div>
  }
</ng-template>
